import React from "react"
import styles from "./FooterCTA.module.css"

const FooterCTA = ({ icon, cta }) => {
  return (
    <div className={styles.footerCta}>
      <div className={styles.footerIconContainer}>
        <i className={`icon icon-${icon}`} />
      </div>
      <p>{cta}</p>
    </div>
  )
}

export default FooterCTA
